<form [formGroup]="form" *ngIf="form">
    <div class="p-d-flex p-flex-column gap-12">
        <div class="p-d-flex gap-12 mt-2">
            <kodit-text-input-field
                formCtrlId="vozac-ime"
                formCtrlLabel="Ime vozača"
                [formCtrl]="form.controls.ime!"
                class="flex-50"
            >
            </kodit-text-input-field>
            <kodit-text-input-field
                formCtrlId="vozac-email"
                formCtrlLabel="Email vozača"
                [formCtrl]="
                    form.controls.email!
                "
                class="flex-50"
                >
            </kodit-text-input-field>
        </div>
        <div class="p-d-flex gap-12 mt-2">
            <kodit-text-input-field
                formCtrlId="vozac-prezime"
                formCtrlLabel="Prezime vozača"
                [formCtrl]="form.controls.prezime!"
                class="flex-50 inputFullWidth"
                >
            </kodit-text-input-field>
            <kodit-text-input-field
                formCtrlId="vozac-telefon"
                formCtrlLabel="Telefon"
                [formCtrl]="form.controls.telefon!"
                class="flex-50"
                >
            </kodit-text-input-field>
        </div>
        <div class="p-d-flex gap-12 mt-2">
            <kodit-text-input-field
                formCtrlId="vozac-registarski-broj"
                formCtrlLabel="Registarski broj vozila"
                [formCtrl]="form.controls.registarskiBrojVozila!"
                class="flex-50"
                >
            </kodit-text-input-field>
            <kodit-text-input-field
                formCtrlId="vozac-br-dozvole"
                formCtrlLabel="Broj vozačke dozvole"
                [formCtrl]="form.controls.brojVozackeDozvole!"
                class="flex-50"
                >
            </kodit-text-input-field>
        </div>
    </div>
</form>
